module.exports = __webpack_public_path__ + "img/weight.8689d090.svg";